import { useEffect, useState } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { getLoginToken , authenticate, AuthorizationAPI, LoginState, ErrorState } from '../Recoil-State';
import { RouteProvider } from './Routes/RouteProvider';
import { Loader } from '../core';

export const AuthProvider = () => {
    const [ loading, setLoading ] = useRecoilState(LoginState);
    const [ error ] = useRecoilState(ErrorState);
    const [ auth, setAuth ] = useRecoilState(authenticate);
    const isToken = useRecoilValue(getLoginToken);

    // set Auth Token on Recoil State
    useEffect(()=> {
        if( isToken ) {
            setAuth(isToken);
        }

        setLoading(true);
        // eslint-disable-next-line
    }, [isToken]);

    useEffect(() => {
      // call auth API 
      if( auth) {
        AuthorizationAPI(auth);
      }
    }, [auth]);


    return (
    <>
        { loading && <Loader size ={40} type= 'full' text ={ error || 'Loading'} className ={error ? 'text-red-500' :''}/>}
        { (!loading ) && (<RouteProvider/>)}
     </>
    )
}